import React from "react";
import styles from "./styles/MetricCards.module.css";

export function MetricLabel({ title, hint }) {
  return (
    <div className={styles.metricLabel}>
      <div className={styles.metricTitle}>{title}</div>
      {hint ? <div className={styles.metricHint}>{hint}</div> : null}
    </div>
  );
}

export function MetricKpi({ title, value, hint }) {
  return (
    <div className={styles.metricKpi}>
      <div className={styles.metricTitle}>{title}</div>
      <div className={styles.metricValue}>{value}</div>
      {hint ? <div className={styles.metricHint}>{hint}</div> : null}
    </div>
  );
}
